import { useQuery } from '@tanstack/react-query';
import type { DemandPreview, PlanningsData, StoragesData } from './types';

export const QUERY_KEYS = {
  demandPreview: ['short-term-optimization', 'demand-preview'] as const,
  plannings:     ['short-term-optimization', 'plannings'] as const,
  storages:      ['short-term-optimization', 'storages'] as const,
};

export function useDemandPreview() {
  return useQuery({
    queryKey: QUERY_KEYS.demandPreview,
    queryFn: async () => {
      const response = await fetch('/api/short-term-optimization/demand-preview');
      if (!response.ok) throw new Error('Impossible de charger la prévisualisation des données.');
      return response.json() as Promise<DemandPreview>;
    },
  });
}

export function usePlannings() {
  return useQuery({
    queryKey: QUERY_KEYS.plannings,
    queryFn: async () => {
      const response = await fetch('/api/short-term-optimization/plannings');
      if (!response.ok) throw new Error('Impossible de charger les plannings.');
      return response.json() as Promise<PlanningsData>;
    },
  });
}

export function useStorages() {
  return useQuery({
    queryKey: QUERY_KEYS.storages,
    queryFn: async () => {
      const response = await fetch('/api/short-term-optimization/storages');
      if (!response.ok) throw new Error('Impossible de charger les stockages.');
      return response.json() as Promise<StoragesData>;
    },
  });
}
